import { render, staticRenderFns } from "./BeneficiariosListado.vue?vue&type=template&id=1e4128d8&scoped=true&"
import script from "./BeneficiariosListado.vue?vue&type=script&lang=js&"
export * from "./BeneficiariosListado.vue?vue&type=script&lang=js&"
import style0 from "./BeneficiariosListado.vue?vue&type=style&index=0&id=1e4128d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4128d8",
  null
  
)

export default component.exports